import { IContainer, injectContainer } from '../../interface/container';

export interface IFetchHelper {
    fetchWithProgress: (
        request: Request,
        timeout?: number,
        callback?: (progress: number) => void,
    ) => Promise<Response>;
}

const TYPES = {
    IFetchHelper: Symbol.for('IFetchHelper'),
};

export function injectFetchHelper(container: IContainer = injectContainer()): IFetchHelper {
    return container.get<IFetchHelper>(TYPES.IFetchHelper);
}

export function bindFetchHelper(val: IFetchHelper, container: IContainer = injectContainer()) {
    return container.bind<IFetchHelper>(TYPES.IFetchHelper, val);
}

export function unbindFetchHelper(container: IContainer = injectContainer()) {
    return container.remove(TYPES.IFetchHelper);
}
